import care from "./ProductsPage/care.jpg";
import oniniroom from "./ProductsPage/ominiroom.jpg";
import rpm from "./ProductsPage/rpm.jpg";
import videocall from "./ProductsPage/videocall.jpg";
import homedoc from "./ProductsPage/homedoc.jpg";
import care_caption from "./ProductsPage/care.svg";
import homedoc_caption from "./ProductsPage/homedoc.svg";
import ominiroom_caption from "./ProductsPage/ominiroom.svg";
import rpm_caption from "./ProductsPage/rpm.svg";
import videocall_caption from "./ProductsPage/videocall.svg";
import products_banner from "./ProductsPage/products_banner.png";
import products_footer_back from "./ProductsPage/products_footer_back.png";
import overlayback1 from "./ProductsPage/overlayback1.png";
import overlayback2 from "./ProductsPage/overlayback2.png";
import nodataanimation from "./AnimatedIcon/nodataanimation.json";
import pageloader from "./AnimatedIcon/pageloader.json";
import contactpagebanner from "./Contactpage/contactpage-banner.webp";
import checkSmall from "./check_small.svg";
import crossSmall from "./cross_small.svg";

import mediaPageBanner from "./MediaPage/banner.webp";
import brand_assets6 from "./MediaPage/brand-assets-6.png";
import brand_guideline from "./MediaPage/brand_guideline.png";
import int_1 from "./MediaPage/int_1.svg";
import int_2 from "./MediaPage/int_2.svg";
import int_3 from "./MediaPage/int_3.svg";
import int_4 from "./MediaPage/int_4.svg";
import logos from "./MediaPage/logos.png";
import news_1 from "./MediaPage/news_1.png";
import news_2 from "./MediaPage/news_2.png";
import news_3 from "./MediaPage/news_3.png";
import press from "./MediaPage/press.png";
import video_thumb from "./MediaPage/video_thumb.png";
import fastcompany from "./MediaPage/fastcompany.png";
import npr from "./MediaPage/npr.png";
import businessinsider from "./MediaPage/businessinsider.png";
import fortune from "./MediaPage/fortune.png";
import polygon from "./MediaPage/Polygon.svg";

import c2mdLogo from "./dashboardv2/c2md logo-02.png";
import help from "./dashboardv2/help.svg";
import logout from "./dashboardv2/log-out.svg";
import triangle from "./dashboardv2/triangle.svg";
import dashboardVector from "./dashboardv2/vector.png";
import user from "./dashboardv2/user.png";
import prescription from "./dashboardv2/prescription .svg";
import mail from "./dashboardv2/mail.svg";
import phone from "./dashboardv2/phone.svg";
import faq from "./dashboardv2/faq.svg";

import indiaFlag from "./Contactpage/ind.png";
import australiaFlag from "./Contactpage/aus.png";
import uaeFlag from "./Contactpage/uae.png";

import patientDetails from "./ManagePrescription/patientDetails.svg";
import arrow_up from "./ManagePrescription/arrow_up.svg";
import calander from "./ManagePrescription/calander.svg";
import incr from "./ManagePrescription/incr.svg";
import decr from "./ManagePrescription/decr.svg";
import search from "./ManagePrescription/search.svg";
import cnote from "./ManagePrescription/cnote.svg";
import diagnosis from "./ManagePrescription/diagnosis.svg";
import examination from "./ManagePrescription/examination.svg";
import med_history from "./ManagePrescription/med_history.svg";
import symptom from "./ManagePrescription/symptom.svg";
import treatment_advice from "./ManagePrescription/treatment_advice.svg";
import instructions from "./ManagePrescription/instructions.svg";
import reports from "./ManagePrescription/reports.svg";
import medication from "./ManagePrescription/medication.svg";
import investigations from "./ManagePrescription/investigations.svg";
import followup from "./ManagePrescription/followup.svg";
import referal from "./ManagePrescription/referal.svg";
import print from "./ManagePrescription/print.svg";
import diagostic_report from "./ManagePrescription/diagnostic_report.svg"
import fam_history from './ManagePrescription/fam_history.svg';
import mui_select from "./mui_select.png";
import calanderWithSquare from "./calanderWithSquare.svg";
import calanderWithCheck from "./calanderWithCheck.svg";

import calanderWithSquare2 from "./calanderWithSquare.svg";
import calanderWithCheck2 from "./calanderWithCheck.svg";

import uos_landing_cover from "./uos_landing_cover.webp";
import uos_branding from "./uos_branding.png";
import reem_branding from "./reem_branding.png";

import checkRound from "./checkRound.svg";
import closeRound from "./closeRound.svg";

import gangaAppLogo from "./ganga/ganga_app.png";
import start_effect from "./ganga/start_effect1.svg";
import heart_effect from "./ganga/heart_effect1.svg";

import successLottie from "./AnimatedIcon/gangaSuccessLottie.json";

export const AssetStore = {
  mediapage: {
    banner: mediaPageBanner,
    brand_assets6,
    brand_guideline,
    int_1,
    int_2,
    int_3,
    int_4,
    logos,
    news_1,
    news_2,
    news_3,
    press,
    video_thumb,
    fastcompany,
    npr,
    businessinsider,
    fortune,
    polygon,
  },
  dashbaodrV2: {
    c2mdLogo,
    help,
    logout,
    triangle,
    dashboardVector,
    prescription,
    mail,
    phone,
    faq,
    bookImage:
      "https://www.appointment.com/wp-content/uploads/2021/04/pexels-alex-green-5699456.jpg",
    user: "https://www.connect2mydoctor.com/img/doctor-avatar.jpg",
  },
  managePrescription: {
    patientDetails,
    arrow_up,
    calander,
    incr,
    decr,
    search,
    cnote,
    diagnosis,
    examination,
    med_history,
    symptom,
    diagostic_report,
    
    treatment_advice,
    instructions,
    fam_history,
    reports,
    medication,
    investigations,
    followup,
    referal,
    print,
  },
  appointmentHistory: {
    forGreen: calanderWithSquare,
    forYello: calanderWithCheck,
  },
  indiaFlag,
  australiaFlag,
  uaeFlag,
  care,
  oniniroom,
  rpm,
  videocall,
  homedoc,
  care_caption,
  homedoc_caption,
  ominiroom_caption,
  rpm_caption,
  videocall_caption,
  products_banner,
  products_footer_back,
  overlayback1,
  overlayback2,
  nodataanimation,
  contactpagebanner,
  checkSmall,
  crossSmall,
  pageloader,
  mui_select,
  uos_landing_cover,
  uos_branding,
  reem_branding,
  checkRound,
  closeRound,
  gangaAppLogo,
  start_effect,
  heart_effect,
  successLottie,
};
